import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NgOtpInputModule } from 'ng-otp-input';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { EmailVerifyComponent } from './email-verify/email-verify.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { LoginGuard } from '../../core/guards/login.guard';
import { VerifyEmailService } from './services/verify-email.service';

@NgModule({
  providers: [LoginGuard, VerifyEmailService],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    RegistrationFormComponent,
    ConfirmationComponent,
    EmailVerifyComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NzCardModule,
    NzGridModule,
    NzInputModule,
    NzButtonModule,
    NzFormModule,
    NzAlertModule,
    NzIconModule,
    NzDividerModule,
    NgOtpInputModule,
    NzSelectModule,
    NzToolTipModule,
  ],
})
export class AuthModule {}
